import React, { useRef, useState } from 'react';
import BandLayoutPage from '../components/partial/layout/BandLayoutPage.jsx';
import PerformerNavSongList from '../components/partial/navigation/PerformerNavSongList.jsx';
import PerformerSongList from '../components/partial/PerformerSongList.jsx';
import ImportSonglistModal from '../components/partial/modal/ImportSongListModal.jsx';
import { SongSearchProvider } from '../contexts/SongSearchContext.jsx';

const SongListPageWrapper = () => {
  const resetTagFilterRef = useRef(null);
  const [importModalOpen, setImportModalOpen] = useState(false);

  return (
    <SongSearchProvider>
      <BandLayoutPage
        navigation={<PerformerNavSongList onImportSonglist={() => setImportModalOpen(true)} />}
        pageType="song-list"
      >
        <PerformerSongList resetTagFilterRef={resetTagFilterRef} />
      </BandLayoutPage>
      <ImportSonglistModal
        isOpen={importModalOpen}
        onClose={() => setImportModalOpen(false)}
      />
    </SongSearchProvider>
  );
};

export default SongListPageWrapper;
